import { getMonthName } from '../date.js';
import { BaseInstanceRule } from './base-instance-rule.js';
import type { LocalDate } from 'src/utilities/local-date.js';
import { t } from 'src/i18n';

export class YearlyByDayOfMonthInstanceRule extends BaseInstanceRule {
  // Bygges lazy slik at i18n-`t()` kjøres ved kalltid, ikke ved import.
  private static intervalDescriptions(): string[] {
    return [
      '',
      t('recurrence.intervals.yearly.second'),
      t('recurrence.intervals.yearly.third'),
      t('recurrence.intervals.yearly.fourth'),
      t('recurrence.intervals.yearly.fifth'),
      t('recurrence.intervals.yearly.sixth'),
    ];
  }
  private readonly byMonth: number;
  private readonly byMonthDay: number;

  public constructor(byMonth: number, byMonthDay: number) {
    super();
    this.byMonth = byMonth;
    this.byMonthDay = byMonthDay;
  }

  public matches(date: LocalDate): boolean {
    return date.month() === this.byMonth && date.day() === this.byMonthDay;
  }

  public optionsToString(interval: number): string {
    return 'FREQ=YEARLY;INTERVAL=' + interval + ';BYMONTHDAY=' + this.byMonthDay + ';BYMONTH=' + this.byMonth;
  }

  public scheduleDescription(interval: number): string {
    const i = YearlyByDayOfMonthInstanceRule.intervalDescriptions()[interval - 1];
    return t('recurrence.descriptions.yearlyByDayOfMonth', {
      interval: i,
      day: this.byMonthDay,
      month: getMonthName(this.byMonth),
    });
  }
}
